<div *ngIf="promotions.length > 0" class="d-block card container col col-xg-12 col-lg-12 col-md-12 col-xs-12 text-center w-100 p-0 m-0 pt-5" style="z-index: 0;">
  <div class="top-content">
    <div class="container-fluid">

      <div class="native-carousel position-relative promotions-big">
        <button type="button" class="carousel-arrow carousel-arrow-left" (click)="carousel.prev()" aria-label="Anterior">
          <i class="bi bi-chevron-left"></i>
        </button>

        <div class="native-carousel-viewport">
          <div class="native-carousel-track"
               [style.width.%]="carousel.trackWidthPercent"
               [style.transform]="'translateX(' + carousel.translatePercent + '%)'"
               [style.transition]="carousel.transitionEnabled ? 'transform 0.7s ease' : 'none'">
            <div class="native-carousel-slide" *ngFor="let slide of carousel.extended" [style.width.%]="carousel.slideWidthPercent">
              <div (click)="applyPromotion(slide.data)" class="container-link position-relative mx-3">

                <img
                      usbLazyLoadImage
                      loading="lazy"
                      [lazyImage]="slide.data.badge_banner_path || 'assets/default-promo.jpg'"
                      class="img-fluid mx-auto d-block image-brightness px-2"
                      alt="{{ slide.data.name }}">
                <div class="placeholder position-absolute"
                        [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                        role="status"
                        style=" top: 50%; left: 50%; transform: translate(-50%, -50%);">
                </div>
                <div class="carousel-caption d-none d-md-block p-0">
                  <div>
                    <h6 class="text-center destination-title">{{slide.data.name}}</h6>
                  </div>
                  <div class="gallery-btn text-center">
                    <button class="btn btn-usblick" [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"></button>
                  </div>
                  <p class="text-center destination-sub-title">{{slide.data.promotion_type_name}}</p>
                  <hr class="separator">
                  <p class="text-center destination-footer-title">Válido del {{slide.data.booking_window_start | date}} al {{slide.data.booking_window_end | date}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="button" class="carousel-arrow carousel-arrow-right" (click)="carousel.next()" aria-label="Siguiente">
          <i class="bi bi-chevron-right" style="font-size: 50px"></i>
        </button>
      </div>

    </div>
  </div>
</div>

<usb-navbar-search-categories #navBarSearchCategories [getClientsSettingAppBooking]="getClientsSettingAppBooking" style="visibility: hidden;"></usb-navbar-search-categories>
